// extracted by mini-css-extract-plugin
export default {"card":"Card_card__l9+Xd","title":"Card_title__jNZMt"};